export enum AssignedLessonStateEnum {
  Unstarted = 0,
  InProgress = 1,
  Finished = 2,
}
